import _createForOfIteratorHelper from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _regeneratorRuntime from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { getUserInfoMap, getGameServerMap } from "@/utils/dictionary";
import { roleClearStateList } from "@/define/roleClearDefine";
export default {
  props: ['tableData', 'isApprove'],
  data: function data() {
    return {
      userInfoMap: {},
      gameServerMap: {},
      stateTag: {
        1: "info",
        2: "danger",
        3: "success"
      }
    };
  },
  created: function created() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getUserInfoMap();
          case 2:
            _this.userInfoMap = _context.sent;
            _context.next = 5;
            return getGameServerMap();
          case 5:
            _this.gameServerMap = _context.sent;
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    getStateName: function getStateName(id) {
      var _iterator = _createForOfIteratorHelper(roleClearStateList),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          if (item.id == id) return item.label;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return '??';
    },
    onEdit: function onEdit(data) {
      this.$emit("edit", data);
    },
    onApprove: function onApprove(data) {
      this.$emit("approve", data);
    },
    getEditDisabled: function getEditDisabled(row) {
      return row.state == 3; // 1:待审核，2:审核拒绝，3:审核通过
    },
    getApproveDisabled: function getApproveDisabled(row) {
      return row.state > 1; // 1:待审核，2:审核拒绝，3:审核通过
    }
  }
};